<template>
  <div />
</template>



<script>
  export default {
    name: 'CreateAccountPage',

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        this.$openModal('createAccount', null);

        this.$router.replace({
          name: 'orderMenu',
          params: {
            merchantId: this.$route.params.merchantId
          }
        });
      }
    }
  };
</script>
